import { AxiosRequestConfig, AxiosResponse } from "axios";

export abstract class HttpInterceptor {
  public onRequest(request: AxiosRequestConfig): AxiosRequestConfig | Promise<AxiosRequestConfig> {
    return request;
  }

  public onRequestError(error: Error): void | Promise<void> {
    throw error;
  }

  public onResponse<T>(response: AxiosResponse): T | Promise<T> {
    return response as unknown as T;
  }

  public onResponseError(error: Error): void | Promise<void> {
    throw error;
  }
}
